import React from 'react';
import PropTypes from 'prop-types';
/* eslint no-unused-vars: [2, { "varsIgnorePattern": "[IconConstants]" }] */
import IconConstants from 'components/shared/icons/IconConstants';
import provideTranslations from 'decorators/provideTranslations';

@provideTranslations('Icons')
class ArrowContainer extends React.Component {
  render() {
    return <ArrowIcon {...this.props} />;
  }
}

class ArrowIcon extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    direction: PropTypes.string,
    size: PropTypes.number,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
    color: IconConstants.WHITE,
    direction: 'right',
    size: 16,
  };

  static directions = {
    right: {
      title: 'AA_Arrow_Right_Icon_Title',
      desc: 'AA_Arrow_Right_Icon_Desc',
      rotate: 0,
    },
    left: {
      title: 'AA_Arrow_Left_Icon_Title',
      desc: 'AA_Arrow_Left_Icon_Desc',
      rotate: 180,
    },
  }

  render() {
    const {
      className,
      color,
      direction,
      size,
    } = this.props;
    const { getString } = this.context;

    const arrowDirection = ArrowIcon.directions[direction];

    return (
      <svg
        width={size}
        height={size}
        className={className}
        viewBox="0 0 16 16"
        role="img"
        aria-label={getString(arrowDirection.desc)}
      >
        <title>{getString(arrowDirection.title)}</title>
        <desc>{getString(arrowDirection.desc)}</desc>
        <polygon
          role="presentation"
          stroke="none"
          fill={color}
          fillRule="evenodd"
          transform={`rotate(${arrowDirection.rotate} 8 8)`}
          points="8,0 6.6,1.4 12.2,7 0,7 0,9 12.2,9 6.6,14.6 8,16 16,8"
        />
      </svg>
    );
  }
}

export default ArrowContainer;
